<template>
  <div class="twitter-post-preview-footer">
    <div v-for="action in actions" :key="action.src" class="twitter-post-preview-footer__action">
      <img :src="`/wp-content/themes/snappy-theme/assets/images/builders/${action.iconName}.svg`" alt="Twitter" />
      <img
        v-if="action.lines"
        :src="`/wp-content/themes/snappy-theme/assets/images/builders/three_lines.svg`"
        alt="Comments"
        class="linkedin-post-preview-footer__lines"
      />
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    actions: [
      {
        iconName: 'comment_twitter',
        lines: true,
      },
      {
        iconName: 'share_twitter',
        lines: true,
      },
      {
        iconName: 'like_twitter',
        lines: true,
      },
      {iconName: 'upload_twitter'},
      {iconName: 'bars_twitter'},
    ],
  }),
};
</script>

<style lang="scss" scoped>
@import '../../../../../../../sass/web/_variables';

.twitter-post-preview-footer {
  padding-top: 5px;
  color: $color-denim;
  display: flex;
  margin-right: 20px;
  &__action {
    display: flex;
    align-items: center;
    gap: 5px;
    margin-right: 40px;
    transform: scale(0.7);
  }
}
</style>
